/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Fn } from './Fn';

class EnterpriseStatementDetail extends Fn {
    constructor() {
        super();
        this.baseUrl += '/enterpriseStatementDetail';
    }

    findListWithStat({
        fullName,
        sex,
        idCardNo,
        tel,
        certCatId,
        certExamType,
        groupingSn,
        enterpriseName,
        enterpriseCooperationName,
        examApplyTime,
        settlementRulesName,
        createTime,
        availableTime,
        statementName,
        statementCode,
        enterpriseStatementStatus,
        voucherSn,
        remarks,
        enterpriseStatementDetailStatus,
        enterpriseStatementId,
        isRelatedVoucher,
        enterpriseStatementIdNull,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let examApplyTimeBegin = null;
        let examApplyTimeEnd = null;
        if (examApplyTime != null && examApplyTime.length === 2) {
            [examApplyTimeBegin, examApplyTimeEnd] = examApplyTime;
        }
        let createTimeBegin = null;
        let createTimeEnd = null;
        if (createTime != null && createTime.length === 2) {
            [createTimeBegin, createTimeEnd] = createTime;
        }
        let availableTimeBegin = null;
        let availableTimeEnd = null;
        if (availableTime != null && availableTime.length === 2) {
            [availableTimeBegin, availableTimeEnd] = availableTime;
        }
        return super.get('/findListWithStat', {
            fullName,
            sex,
            idCardNo,
            tel,
            certCatId,
            certExamType,
            groupingSn,
            enterpriseName,
            enterpriseCooperationName,
            examApplyTimeBegin,
            examApplyTimeEnd,
            settlementRulesName,
            createTimeBegin,
            createTimeEnd,
            availableTimeBegin,
            availableTimeEnd,
            statementName,
            statementCode,
            enterpriseStatementStatus,
            voucherSn,
            remarks,
            enterpriseStatementDetailStatus,
            enterpriseStatementId,
            isRelatedVoucher,
            enterpriseStatementIdNull,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/get', { id });
    }

    editDetailRemarks({ enterpriseStatementDetailId, remarks } = {}) {
        return super.post('/editDetailRemarks', {
            enterpriseStatementDetailId,
            remarks,
        });
    }

    relatedStatement({ ids, enterpriseStatementId }) {
        return super.post('/relatedStatement', { ids, enterpriseStatementId });
    }

    cancelRelatedStatement({ ids }) {
        return super.post('/cancelRelatedStatement', { ids });
    }

    relatedStatementVoucher({ ids, enterpriseStatementVoucherId }) {
        return super.post('/relatedStatementVoucher', { ids, enterpriseStatementVoucherId });
    }

    relatedStatementVoucherItem({ id, voucherList }) {
        return super.post('/relatedStatementVoucherItem', { id, voucherList });
    }

    backWaitRelated({ ids }) {
        return super.post('/backWaitRelated', { ids });
    }
}

export default new EnterpriseStatementDetail();
export { EnterpriseStatementDetail };
